// src/FileUpload.js
import React, { useRef, useState } from "react";
import "./FileUpload.css";
import { API_BASE } from "./config";

export default function FileUpload({ onUploadSuccess }) {
  const inputRef = useRef(null);
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");
  const [fileName, setFileName] = useState("");

  const openPicker = () => {
    if (status !== "uploading") inputRef.current?.click();
  };

  const onSelect = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;

    if (f.type !== "application/pdf") {
      setStatus("error");
      setMessage("Lütfen PDF dosyası yükleyin.");
      resetOnlyInput();
      return;
    }
    if (f.size > 30 * 1024 * 1024) {
      setStatus("error");
      setMessage("Dosya 30 MB sınırını aşıyor. Lütfen bölerek yükleyin.");
      resetOnlyInput();
      return;
    }

    setFileName(f.name);
    uploadFile(f);
  };

  const resetOnlyInput = () => {
    if (inputRef.current) inputRef.current.value = "";
  };

  const uploadFile = async (file) => {
    const controller = new AbortController();
    // Timeout süresini 2 dakikaya çıkarıyoruz (büyük PDF'ler için)
    const timeoutId = setTimeout(() => controller.abort(), 120000); // 2 dakika

    try {
      setStatus("uploading");
      setMessage("Yükleniyor...");

      const formData = new FormData();
      formData.append("file", file);

      const res = await fetch(`${API_BASE}/upload`, {
        method: "POST",
        body: formData,
        signal: controller.signal,
        // Credential ayarını kaldırıyoruz - bazen sorun çıkarabiliyor
      });

      if (!res.ok) {
        let errorMessage = `Yükleme başarısız (HTTP ${res.status})`;
        try {
          const errorData = await res.json();
          errorMessage = errorData?.detail || errorData?.message || errorMessage;
        } catch (e) {
          // JSON parse edilemezse varsayılan mesajı kullan
        }
        throw new Error(errorMessage);
      }

      const data = await res.json();
      if (!data?.conv_id) {
        throw new Error("Sunucudan conv_id dönmedi.");
      }

      setStatus("success");
      setMessage("PDF başarıyla yüklendi.");
      onUploadSuccess?.(data.conv_id);
    } catch (err) {
      let errorMessage = "Yükleme sırasında hata oluştu.";
      
      if (err.name === "AbortError") {
        errorMessage = "Yükleme zaman aşımına uğradı. Lütfen daha küçük bir dosya deneyin.";
      } else if (err.message) {
        errorMessage = err.message;
      }

      setStatus("error");
      setMessage(errorMessage);
      console.error("Upload error:", err);
    } finally {
      clearTimeout(timeoutId);
      resetOnlyInput();
    }
  };

  return (
    <div className="upload-section">
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf"
        onChange={onSelect}
        className="file-input"
      />

      <button
        className="upload-btn"
        onClick={openPicker}
        disabled={status === "uploading"}
      >
        {status === "uploading" ? "Yükleniyor..." : "Dosya yükle"}
      </button>

      <div className="upload-info-text">Sadece PDF dosyaları destekleniyor</div>

      {fileName && status !== "uploading" && (
        <div className="upload-fileinfo">Seçilen: {fileName}</div>
      )}
      {status === "success" && (
        <div className="upload-success-alert">{message}</div>
      )}
      {status === "error" && (
        <div className="upload-error-alert">{message}</div>
      )}
    </div>
  );
}